import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import * as fromActions from "./activate-account.actions"
import * as fromGraphql from './activate-account.graphql';
import {BaseResponse} from "../../../base.entity";
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";


@Injectable()
export class ActivateAccountEffects {

  activateAccount$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.activateAccount),
      switchMap((action) => {
        return this.apollo.mutate({
            mutation: fromGraphql.activateAccount,
            variables:{
              input: action?.input,
            }
        })
          .pipe(
            this.notificationService.catchError('Problem occurred while saving record'),
            map(({ data }: any) => {

              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(fromActions.upsertActivateAccount({ activateAccount: result?.data }));
                  this.notificationService.successMessage('Created Successfully ');
                } else {
                  this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
                }
              }
            })
          )
      })

    ), { dispatch: false })

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}
}
